import { InternalCanvas } from '../canvas';
import { isMap } from '../util';
import { DrawingTool } from './tool';

export class EraserTool extends DrawingTool {
    public handleMouseMove(
        canvas: InternalCanvas,
        { e: { buttons }, target }: fabric.IEvent & { e: MouseEvent },
    ): boolean {
        if (target && buttons === 1 && !isMap(target)) {
            canvas.removeObjects(target);
        }

        return true;
    }
}
